import React from "react";
import { OutOfBoundsNumberOfGuests } from "~/applications/OfferSearch/Domain/OutOfBoundsNumberOfGuests";
import { PastStay } from "~/applications/OfferSearch/Domain/PastStay";

type ErrorBoundaryProps = {
  children: React.ReactNode;
  renderOnPastStay: () => React.ReactNode;
  renderOnOutOfBoundsNumberOfGuests: () => React.ReactNode;
};

type NoErrorState = {
  error: null;
  hasError: false;
};

type HasErrorState = {
  error: Error;
  hasError: true;
};

type ErrorBoundaryState = HasErrorState | NoErrorState;

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error | PastStay): ErrorBoundaryState {
    if (error instanceof PastStay) {
      return { hasError: true, error };
    }

    if (error instanceof OutOfBoundsNumberOfGuests) {
      return { hasError: true, error };
    }

    throw error;
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const error = this.state.error;

    if (error instanceof PastStay) {
      return this.props.renderOnPastStay();
    }

    if (error instanceof OutOfBoundsNumberOfGuests) {
      return this.props.renderOnOutOfBoundsNumberOfGuests();
    }
  }
}

export default ErrorBoundary;
